import * as React from 'react'

import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import Employee from 'modules/employees/store/models/Employee'

interface Props {
  form: Form
}

const getTerminationReasonsOptions = () => {
  return [
    {
      label: i18n.t('employees.termination.company_decision'),
      value: Employee.TERMINATION_REASON_TYPE.company,
    },
    {
      label: i18n.t('employees.termination.employee_decision'),
      value: Employee.TERMINATION_REASON_TYPE.employee,
    },
    {
      label: i18n.t('employees.termination.others'),
      value: Employee.TERMINATION_REASON_TYPE.others,
    },
  ]
}

const TerminationReason = ({ form }: Props) => {
  const options = getTerminationReasonsOptions()
  return (
    <Select
      mandatory
      options={options}
      field={form.get('termination_reason_type')}
      label={i18n.t('employees.termination.termination_reason')}
      none={i18n.t('employees.termination.termination_empty')}
    />
  )
}

export default observer(TerminationReason)
